import styled from "styled-components";
import { ImageIcon } from "../../../../../components/icons";
import {
  Typography,
  TypographyVariant,
} from "../../../../../components/ui-kit";

const DescWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Image = styled.img`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  margin-right: 12px;
  background: #eeeeee;
  border-radius: 5px;
  object-fit: cover;
`;

const ProductName = styled(Typography)`
  line-height: 20px;
`;

const EmptyImage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  box-sizing: border-box;
  margin-right: 12px;
  background: #eeeeee;
  border: 1px solid #dbe3eb;
  border-radius: 5px;
  object-fit: cover;
  svg {
    scale: 1.1;
  }
`;

const Info = styled.div<{ maxWidth?: string }>`
  display: flex;
  flex-direction: column;
  p {
    max-width: ${({ maxWidth }) => maxWidth ?? "auto"};
    overflow-x: auto;
    word-break: break-all;
  }
`;

interface DescriptionColumnProps {
  image?: string;
  productName: string;
  productVariantName?: string;
  className?: string;
  withoutImage?: boolean;
  withoutProductName?: boolean;
  maxWidth?: string;
}

export const DescriptionColumn: React.FunctionComponent<
  DescriptionColumnProps
> = ({
  image,
  productName,
  className,
  productVariantName,
  withoutImage,
  withoutProductName,
  maxWidth,
}) => {
  return (
    <DescWrapper className={className}>
      {!withoutImage && (
        <div>
          {image ? (
            <Image src={image} alt={"product icon"} />
          ) : (
            <EmptyImage>
              <ImageIcon />
            </EmptyImage>
          )}
        </div>
      )}
      <Info maxWidth={maxWidth}>
        {!withoutProductName && (
          <ProductName variant={TypographyVariant.BODY3}>
            {productName}
          </ProductName>
        )}
        <Typography variant={TypographyVariant.BODY7} color="#6C6C8A">
          {productVariantName}
        </Typography>
      </Info>
    </DescWrapper>
  );
};
